import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-deleted-items-mobile-explanation',
    templateUrl: './deleted-items-mobile-explanation.component.html',
    styleUrls: ['./deleted-items-mobile-explanation.component.scss'],
    standalone: false
})
export class DeletedItemsMobileExplanationComponent implements OnInit {

  constructor(public themeService: ThemeService) { }

  ngOnInit() {
  }

}
